import translations from '../raws/translation.json'

class Translator {
  constructor() {
    if (Translator.instance) {
      return Translator.instance
    }

    this.currentLang = 'fr'
    this.translations = translations
    Translator.instance = this
  }

  init(lang = 'fr') {
    this.currentLang = lang || this.currentLang
  }


  translate(key, vars = {}) {
    console.log("make tranlation", key, vars, this.translations)
    const keys = key.split('.')
    let value = this.translations[this.currentLang]||this.translations.fr

    for (const k of keys) {
      if (value && k in value) {
        value = value[k]
      } else {
        return key
      }
    }

    return value.replace(/\{(\w+)\}/g, (_, v) => vars[v] ?? `{${v}}`)
  }
}

export default new Translator()
